export function ToCurrency(
  value: number,
  defaultValue: any | undefined = undefined,
  decimalPlaces = 0
) {
  if (!value && defaultValue !== undefined) {
    return defaultValue
  }

  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  }).format(value)
}

export const currencyFormat = (num: number) => {
  const formattedNum = num?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  // If number after decimal point is single, add a 0 to it.
  return formattedNum?.replace(/(\.\d)$/, "$10")
}
